var lib_core = require("lib-core");
var ContentServerMetaData = require("../contentServerMetaData.js");

var ComponentMetaData = function () {
    ContentServerMetaData.call(this);

    this.prefix = this.value("prefix", true);
};

lib_core.inherit(ComponentMetaData, ContentServerMetaData);
lib_core.JsonParser.registerClass(ComponentMetaData, "ComponentMetaData");

module.exports = ComponentMetaData;

ComponentMetaData.prototype.assetType = function () {
	return "component";
};

ComponentMetaData.prototype.assetPath = function () {
	return "components/";
};
